module.exports = __webpack_public_path__ + "static/media/pic5.cd480ff7.webp";